if (!customElements.get('tp-pdp-free-gift')) {
  customElements.define('tp-pdp-free-gift', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-gift-add]');
      this.status = this.querySelector('[data-gift-status]');
      if (!this.button || !this.status) return;
      this.button.disabled = this.adding || this.dataset.available !== 'true' || !this.dataset.variantId;
      this.button.addEventListener('click', this.addGift);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.addGift);
    }

    async readJson(response) {
      const isJson = /(?:application|text)\/(?:[\w.+-]*\+)?(?:json|javascript)\b/i.test(response.headers.get('Content-Type') || '');
      if (!response.ok) {
        const error = isJson ? await response.json() : null;
        throw new Error(typeof error?.description === 'string' ? error.description : this.dataset.errorMessage);
      }
      if (!isJson) throw new Error(this.dataset.errorMessage);
      return response.json();
    }

    addGift = async () => {
      if (this.adding || this.button.disabled) return;
      const variantId = this.dataset.variantId;
      if (!variantId) return;

      this.adding = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.status.textContent = '';
      this.status.removeAttribute('data-error');
      let added = false;

      try {
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', {
          bubbles: true,
          detail: { sections },
        }));
        const sectionIds = [...new Set(sections)].slice(0, 5);
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: sectionIds,
            sections_url: window.location.pathname,
          }),
        });
        const result = await this.readJson(response);
        if (result.status) throw new Error(result.description || this.dataset.errorMessage);
        added = true;
        this.status.textContent = this.dataset.addedMessage;
        document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: result } }));

        const drawer = document.querySelector('cart-drawer');
        const pubsub = window.FoxTheme?.pubsub;
        if (!drawer?.show || !pubsub || window.FoxTheme?.settings?.cartType === 'page') {
          window.location.assign(this.dataset.cartUrl);
          return;
        }

        const cartResponse = await fetch(`${this.dataset.cartUrl}.js`, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' },
        });
        const cart = await this.readJson(cartResponse);
        cart.sections = result.sections || {};
        if (!sectionIds.length || sectionIds.some((id) => typeof cart.sections[id] !== 'string')) {
          window.location.assign(this.dataset.cartUrl);
          return;
        }
        pubsub.publish(pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
        drawer.show(this.button);
      } catch (error) {
        if (added) {
          window.location.assign(this.dataset.cartUrl);
          return;
        }
        this.status.setAttribute('data-error', '');
        this.status.textContent = error instanceof TypeError ? this.dataset.errorMessage : error.message || this.dataset.errorMessage;
      } finally {
        this.adding = false;
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
      }
    };
  });
}
